<template>
  <div class="table-wrapper" unselectable="on">
    <LoaderWait v-show="loading"/>
    <table class="main-table">
      <tr>
        <td class="td-logo" width="30%"><img :src="logo"></td>
        <td width="40%" align="center" style="vertical-align: top"><div class="info-text">Оплата {{ nameProv }}</div></td>
        <td width="30%"></td>
      </tr>
      <tr>
        <td class="td-row" colspan="3" align="center">
          <div class="input-head-text"><span v-if="stepCount > 0">Введите: {{ fields[step].label || ''}}</span> <span v-show="step > 1">({{ step + 1 }} / {{ stepCount }})</span></div>
        </td>
      </tr>
      <tr>
        <td class="td-row" colspan="3" align="center">
          <div class="fon-input">
            <input type="text" readonly class="input-field" v-model="maskedNumber">
            <img @click="clickBsKey" class="bnt-key-bs" src="/imgs/btn_bs_1.png">
          </div>
        </td>
      </tr>
      <tr v-show="isLiteralKeyboard">
        <td class="td-row" colspan="3" align="center">
          <KeyboardLiteral :on-click="onClickKey"></KeyboardLiteral>
        </td>
      </tr>
      <tr v-show="!isLiteralKeyboard">
        <td class="td-row" width="30%">
        </td>
        <td width="40%" align="center">
          <KeyboardDigital :on-click="onClickKey"></KeyboardDigital>
        </td>
        <td width="30%">
        </td>
      </tr>
      <tr>
        <td class="td-nav" width="30%">
          <img @click="backClick" id="btn_back" src="/imgs/back_1.png">
        </td>
        <td width="40%" align="center">
          <img @click="mainClick" id="btn_menu" src="/imgs/menu_impay_1.png">
        </td>
        <td width="30%" align="right">
          <img @click="fwdClick" ref="btnFwd" src="/imgs/fwd_1.png" v-show="checkedValue">
        </td>
      </tr>
    </table>
    <MessageBox :message="errorMessage" v-show="showMessage" :on-close="messageClose"></MessageBox>
  </div>
</template>

<script>
import LoaderWait from "@/components/LoaderWait.vue";
import KeyboardLiteral from "@/components/KeyboardLiteral.vue";
import KeyboardDigital from "@/components/KeyboardDigital.vue";
import MessageBox from "@/components/MessageBox.vue";
import { formatMask } from "@/utils/format_mask.js";

export default {
  name: "InputNumberPage",
  components: { MessageBox, KeyboardDigital, KeyboardLiteral, LoaderWait },
  data () {
    return {
      loading: false,
      timer: null,
      number: '',
      maskedNumber: '',
      step: 0,
      inputs: [],
      showMessage: false,
      errorMessage: '',
      messagePromiseResolver: null,
    }
  },
  computed: {
    isLiteralKeyboard() {
      return this.stepCount > 0 ? this.fields[this.step].keyboardLiteral : false
    },
    checkedValue() {
      const regex = new RegExp(this.stepCount > 0 ? this.fields[this.step].regexp : '');
      return regex.test(this.number)
    },
    provId() {
      const data = this.$store.getters.SELECT_PROV
      if (data !== null) {
        return data
      } else {
        return null
      }
    },
    prov() {
      const data = this.$store.getters.PROV_INFO
      if (data !== null) {
        return data
      } else {
        return null
      }
    },
    user() {
      const data = this.$store.getters.GET_USER_PROFILE
      if (data !== null) {
        return data
      } else {
        return null
      }
    },
    fields() {
      if (this.prov !== null) {
        return this.prov.fields;
      }
      return []
    },
    stepCount() {
      return this.fields.length
    },
    logo() {
      if (this.prov !== null) {
        return '/imgs/op/' + this.prov.img;
      }
      return '/imgs/logo_impay.png'
    },
    nameProv() {
      if (this.prov !== null) {
        return this.prov.name
      }
      return 'услуги'
    }
  },
  mounted () {
    this.inputs = []
    this.number = ''
    this.maskedNumber = ''
    this.updateTimer()
    this.loadInfo()
  },
  methods: {
    updateTimer() {
      this.stopTimer()
      this.timer = setTimeout(() => this.timerExit(), 120000)
    },
    stopTimer() {
      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    timerExit() {
      this.$store.dispatch('AUTH_LOGOUT')
    },
    loadInfo() {
      this.loading = true
      this.$store.dispatch('GET_PROV_INFO', {
        id: this.provId,
      }).then((res) => {
        this.loading = false
        if (res.status === 1 && this.stepCount > 0) {
          this.maskedNumber = formatMask(this.number, this.fields[this.step].mask)
        }
      }).catch((e) => {
        this.loading = false
        if (e.response !== undefined && e.response.status === 401) {
          this.$store.dispatch('AUTH_LOGOUT')
        }
      })
    },
    onClickKey(key) {
      this.updateTimer()
      if (this.number.length < this.fields[this.step].maxLength) {
        this.number = this.number + key
        this.maskedNumber = formatMask(this.number, this.fields[this.step].mask)
      }
    },
    clickBsKey() {
      this.updateTimer()
      this.number = this.number.substring(0, this.number.length - 1)
      this.maskedNumber = formatMask(this.number, this.fields[this.step].mask)
    },
    fwdClick() {
      const regex = new RegExp(this.stepCount > 0 ? this.fields[this.step].regexp : '');
      if (regex.test(this.number)) {
        this.stopTimer()
        if (this.step < this.stepCount - 1) {
          this.inputs.push(this.number)
          this.number = '';
          this.maskedNumber = '';
          this.step++
        } else {
          const inputs = [...this.inputs, ...[this.number]];
          this.$store.dispatch('SAVE_INPUTS_PROV', {
            inputs: inputs,
          }).then(() => {
            this.$router.push('input-sum')
          })
        }
      }
    },
    backClick() {
      if (this.step > 0) {
        this.updateTimer()
        this.inputs.pop()
        this.step--
        this.number = '';
        this.maskedNumber = '';
      } else {
        this.stopTimer()
        this.$router.go(-1)
      }
    },
    mainClick() {
      this.stopTimer()
      this.$router.go(-1)
    },
    messageShow(message) {
      this.showMessage = true;
      this.errorMessage = message;
      // Возвращаем Promise, который будет разрешён в messageClose
      return new Promise((resolve) => {
        this.messagePromiseResolver = resolve;
      });
    },
    messageClose() {
      this.showMessage = false;
      this.errorMessage = '';
      // Разрешаем Promise, если он существует
      if (this.messagePromiseResolver) {
        this.messagePromiseResolver();
        this.messagePromiseResolver = null;
      }
    }
  }
}
</script>

<style scoped>

</style>
